import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SecData {
  secDataDetails: any;
}

interface SecDataState {
  value: SecData;
  showHeaderFlag: boolean; // Change to boolean
  isAch: string;
}

const initialState: SecDataState = {
  value: {
    secDataDetails: [],
  },
  showHeaderFlag: true, // Change to boolean
  isAch: "",
};

const getSecDataSlice = createSlice({
  name: "getSecData",
  initialState: initialState,
  reducers: {
    setSecContent: (state, action: PayloadAction<string>) => {
      state.value.secDataDetails = action.payload;
    },
    setSecACHFlag: (state, action: PayloadAction<string>) => {
      state.isAch = action.payload;
    },
    setShowHeaderFlag: (state, action: PayloadAction<boolean>) => { // Change payload type
      state.showHeaderFlag = action.payload;
    },
  },
});

export const { setSecContent, setSecACHFlag, setShowHeaderFlag } =
  getSecDataSlice.actions;

export default getSecDataSlice.reducer;
